import { Fragment } from 'react';

import type { MenuProps } from './types';

import { FilterComparer } from '../common';
import { useFilterTranslate } from '../filter-utils';
import { FilterListItem } from '../list-item';

const DEFAULT_BOOLEAN_COMPARERS = ['is'] satisfies Array<FilterComparer>;

type BooleanComparer = (typeof DEFAULT_BOOLEAN_COMPARERS)[number];

export const isValidBooleanComparer = (comparer: FilterComparer): comparer is BooleanComparer => {
  return DEFAULT_BOOLEAN_COMPARERS.includes(comparer as BooleanComparer);
};

export const BooleanMenu = ({ state, actions }: MenuProps) => {
  const { t } = useFilterTranslate();

  const options = [
    { value: 'true', label: t('core.yes') },
    { value: 'false', label: t('core.no') },
  ];

  return (
    <Fragment>
      {options.map((option) => {
        const isSelected = state.value === option.value;

        return (
          <FilterListItem
            key={option.value}
            isActive={isSelected}
            label={option.label}
            onClick={() => {
              actions.applyFilter({
                ...state,
                comparer: 'is',
                value: option.value,
              });
            }}
          />
        );
      })}
    </Fragment>
  );
};
